
const userprofileview = [{"key":"userprofile.flash.ispublished","string":"Váš profil byl zveřejněn na odborné platformě."},{"key":"userprofile.flash.unpublish","string":"Pro zrušení zveřejnění klikněte zde."},{"key":"userprofile.flash.isnotpublished","string":"Váš profil zatím nebyl zveřejněn na odborné platformě."},{"key":"userprofile.flash.publish","string":"Pro zveřejnění klikněte zde."}]

export default userprofileview



// WEBPACK FOOTER //
// ./src/i18n/cs/adduserprofile/userprofileview.js